export default {
	configTasks: {
		add: "Добавить",
		addTask: "Создать зачаду",
		editTask: "Редактировать задачу",
		editParams: "Редактировать параметры",
		delete: "Удалить",
		view: "Вид",
		compact: "Оптимальный",
		full: "Полный",
		export: "Экспорт",
		insert: "Добавить",
		insertTooltip: "Скрипт добавления задач",
		delete: "Удалить",
		deleteTooltip: "Скрипт удаления задач",
		noTasksError: "Не выбрана ни одна задача",
		deleteWarning: "Это действие удалит эту задачу",
		attention: "Внимание",
		cancel: "Отмена",
		taskDeleted: "Задача удалена, уточните Cron",
		paramsEdited: "Параметры изменены, уточните Cron",
		yes: "Да",
		no: "Нет"
	},
	configTree: {
		selectActionWithBase: "Выберите действие с базой:",
		untieBaseAndDelete: "Отвязать базу от приложения и удалить",
		untieBase: "Отвязать базу от приложения",
		untieBaseFromAllAppsAndDelete: "Отвязать базу от всех приложений и удалить",
		untieBaseFromAllApps: "Отвязать базу от всех приложений",
		cancel: "Отменить",
		selectActionWithApp: "Выберите действие с приложением:",
		linkedBasesNumber: "Все привязанные базы:",
		selectBaseToUnselect: "Выберите базы, которые отвязать от приложения:",
		unlinkSelectedBases: "Отвязать выбранные базы от приложения",
		selectAllBases: "Выбрать все базы",
		unselectAllBases: "Отменить все базы",
		noLinkedBases: "К данному приложению не привязано баз",
		deleteApp: "Удалить приложение",
		enterData: "Введите данные нового приложения. Копируется:",
		attentionAppCopy: "Внимание: копирование приложения выполняется в пределах одного сервера",
		name: "Название",
		alias: "Алиас",
		path: "Путь",
		add: "Добавить",
		fastCreate: "Быстрое создание базы",
		copy: "Копировать",
		edit: "Редактировать",
		delete: "Удалить",
		refreshData: "Обновить данные",
		refreshServerSynchrDate: "Обновить дату синхронизации серверов",
		createServer: "Создать сервер",
		exportManagerCfg: "Экспорт manager.cfg",
		importManagerCfg: "Просмотр manager.cfg",
		export: "Экспорт",
		exportManagerQuestion: "Экспортировать manager.cfg?",
		createManagerQuestion: "Создать manager.cfg?",
		managerFileChanged: "Файл manager.cfg изменен вручную. Дата изменения файла: {fileDate}, дата экспорта базы: {baseDate}",
		managerFileUnchanged: "Перезаписать файл manager.cfg? Дата изменения файла: {fileDate}, дата экспорта базы: {baseDate}",
		enterNewAppName: "Введите название нового приложения",
		enterNewPath: "Введите путь нового приложения",
		enterNameForBaseFastCreate: "Введите название базы для быстрого создания (остальные значения по умолчанию)",
		back: "Назад",
		wrongFormat:"Неверный формат ввода",
		checkAccess:"Проверьте разрешения пользователей для этой связи. По умолчанию доступ запрещен",
		desirableEnterAlias:"Желательно заполнять поле 'Алиас'. Продолжать без заполнения?",
		attention:"Внимание",
		continue:"Продолжать",
		comeback:"Вернуться",
		thisActionDeleteServer:"Это действие удалит этот сервер: ",
		cancellation:"Отмена",
		paramDeleteAction: "Это действие удалит этот параметр приложения: ",
		usersPermissionsDeleted: "Разрешения пользователей для этой связи удалены",
		operationNotSelected: "Не выбрана операция",
		selectAppForUnlink: "Выберите приложение для отвязывания",
		selectBaseForUnlink: "Выберите базу для отвязывания",
		selectOperation: "Выберите операцию",
		checkUsersAccessForThisLink: "Проверьте разрешения пользователей для этой связи. По умолчанию доступ запрещен",
		checkAddOK: "Проверь addOk в Config Tree Node",
		serverNotSelected: "Не выбран сервер",
		noTinyAgentOnServer: "На сервере отсутствует tiny агент",
	},
	roleSections: {
		role: "Роль:",
		allow: "Разрешить",
		prohibit: "Запретить",
		view: "Вид",
		compact: "Оптимальный",
		full: "Полный",
		tableHeaders: {
			access: "Доступ",
			available: "Доступно",
			base: "База",
			baseAlias: "Алиас базы",
			baseComment: "Комментарий к базе",
			app: "Приложение",
			appAlias: "Алиас приложения",
			appServer: "Сервер приложения"
		}
	},
	roleTasks: {
		role: "Роль:",
		allow: "Разрешить",
		prohibit: "Запретить",
		view: "Вид",
		compact: "Оптимальный",
		full: "Полный",
		tableHeaders: {
			access: "Доступ",
		}
	},
	sectionTasks: {
		server: "Сервер:",
		app: "Приложение",
		appNotSelected: "Приложение не выбрано",
		launchAllowed: "Запуск разрешен",
		launchDenied: "Запуск запрещен",
		deniedLaunch: "Запретить запуск",
		allowLaunch: "Разрешить запуск",
	}
};
